import '../../scripts/common';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import DiagnosisPage from '../../components/DiagnosisPage';

import './styles.css';

$(() => {
    Header.create();
    Footer.create();
    DiagnosisPage.create();
});
